<template lang="pug">
div.view-z.flex-row.align-items-center
  div.container.text-center
    h1.headline.mb-3.animated.fadeInDown {{ $t('message.denied') }}
    h3.mb-3.animated.fadeInDown {{ $t('message.relogin') }}
    b-button(to="/login" type="button" size="lg" variant="primary").btn-brand.animated.fadeIn
      i.fa.fa-sign-in-alt
      span {{ $t("ui.login") }}
</template>

<script>
export default {
  components: {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.headline {
  font-size: 72px;
  color: #333333;
  text-shadow: -1px -1px 0px rgba(255, 255, 255, 0.3), 1px 1px 0px rgba(0, 0, 0, 0.8);
}
h3 {
  color: #888888;
}
.view-z {
  background: #222;
}
</style>
